var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoples(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.456 6.18103C25.2322 6.64791 25.8744 7.30769 26.3202 8.09622C26.766 8.88476 27.0002 9.77521 27 10.681C27.0002 11.5868 26.766 12.4773 26.3202 13.2658C25.8744 14.0544 25.2322 14.7141 24.456 15.181M33 32.431V31.531C33 28.171 33 26.491 32.346 25.207C31.7708 24.0781 30.8529 23.1603 29.724 22.585M14.25 15.931C14.9394 15.931 15.6221 15.7952 16.2591 15.5314C16.896 15.2676 17.4748 14.8808 17.9623 14.3933C18.4498 13.9058 18.8365 13.3271 19.1004 12.6901C19.3642 12.0532 19.5 11.3705 19.5 10.681C19.5 9.99159 19.3642 9.3089 19.1004 8.67194C18.8365 8.03498 18.4498 7.45623 17.9623 6.96872C17.4748 6.48121 16.896 6.0945 16.2591 5.83066C15.6221 5.56683 14.9394 5.43103 14.25 5.43103C12.8576 5.43103 11.5223 5.98415 10.5377 6.96872C9.55312 7.95329 9 9.28864 9 10.681C9 12.0734 9.55312 13.4088 10.5377 14.3933C11.5223 15.3779 12.8576 15.931 14.25 15.931ZM3 31.531V32.431H25.5V31.531C25.5 28.171 25.5 26.491 24.846 25.207C24.2708 24.0781 23.3529 23.1603 22.224 22.585C20.94 21.931 19.26 21.931 15.9 21.931H12.6C9.24 21.931 7.56 21.931 6.276 22.585C5.14708 23.1603 4.22923 24.0781 3.654 25.207C3 26.491 3 28.171 3 31.531Z",
    stroke: "#271E4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoples);
export default __webpack_public_path__ + "static/media/peoples.f279f28049adf2044264dd6b543fcbdd.svg";
export { ForwardRef as ReactComponent };